import { MultiplierTypeAttributes } from '@/types'
import { UpdateMultiplierTypeMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditMultiplierTypeQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { useEffect, useState } from 'react'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { Button } from '../base/button'

type MultiplierType = EditMultiplierTypeQuery['multiplierTypes']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<UpdateMultiplierTypeMutation, MultiplierTypeAttributes, EditMultiplierTypeQuery, MultiplierType>({
    id,
    initializer: mt => ({
      name: mt.name,
      multiplier: mt.multiplier,
      multiplierType: mt.multiplierType,
      operandQuantity: mt.operandQuantity,
      operandType: mt.operandType,
    }),
    query: EditQuery,
    queryKey: 'multiplierTypes',
    mutation: UpdateMutation,
    resultKey: 'updateMultiplierType'
  })
  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>

      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-1 gap-6">
          { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        </div>
        <div className="flex flex-row gap-6 w-full items-center">
          <span className="w-16">Charge</span>
          <div className="grow grid grid-cols-2 gap-6">
            { formBuilder.buildField({
              name: 'Multiplier',
              field: 'multiplier',
              type: 'positive-integer',
              hideLabel: true
            }) }
            { formBuilder.buildField({
              name: 'Multiplier type',
              field: 'multiplierType',
              type: 'multiplier-type',
              hideLabel: true
            }) }
          </div>
        </div>
        <div className="flex flex-row gap-6 w-full items-center">
          <span className="w-16">per</span>
          <div className="grow grid grid-cols-2 gap-6">
            { formBuilder.buildField({
              name: 'Operand quantity',
              field: 'operandQuantity',
              type: 'positive-integer',
              hideLabel: true
            }) }
            { formBuilder.buildField({
              name: 'Operand type',
              field: 'operandType',
              type: 'multiplier-type',
              hideLabel: true
            }) }
          </div>
        </div>
        <div className="flex flex-col">hire</div>
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
      </div>
      <DeleteDialog
        id={id}
        mutation={DeleteMutation}
        open={showDelete}
        refetchQueries={[TableQuery]}
        setOpen={setShowDelete}
        onSuccess={onDelete}
      />
    </>
  )
}
